import { Component, effect, inject, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { environment } from '@envs/environment';
import { EventType } from 'app/shared/models/websocket/event.type';
import { WsMessageResponse } from 'app/shared/models/websocket/ws-message-response';
import { CognitoService } from 'app/shared/services/cognito.service';
import { ModalService } from 'app/shared/services/modal.service';
import { ReleaseNotesDialogService } from 'app/shared/services/release-notes-dialog.service';
import { WebSocketService } from 'app/shared/services/web-socket.service';
import { GlobalStore } from 'app/shared/store/global.store';
import { PermissionStore } from 'app/shared/store/permission.store';
import { DialogService } from 'primeng/dynamicdialog';
import { Toast } from 'primeng/toast';
import { Subscription } from 'rxjs';

@Component({
  selector: 'inpla-root',
  imports: [RouterOutlet, Toast],
  providers: [ReleaseNotesDialogService, DialogService, ModalService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly titleService: Title = inject(Title);
  private readonly globalStore = inject(GlobalStore);
  private readonly permissionStore = inject(PermissionStore);
  private readonly cognitoService: CognitoService = inject(CognitoService);
  private readonly releaseNotesDialogService: ReleaseNotesDialogService = inject(ReleaseNotesDialogService);
  private readonly websocketService: WebSocketService = inject(WebSocketService);

  private permissionsWsSub: Subscription | undefined;

  constructor() {
    this.onReleaseNotesLoad();
  }

  public ngOnInit(): void {
    this.titleService.setTitle(environment.title);
    this.globalStore.setTheme(localStorage.getItem('indago-theme'));
    this.cognitoService
      .getCurrentSession()
      .then((it) => {
        this.globalStore.setCurrentSession(it);
        this.permissionStore.loadPermissions();
        this.initPermissionsWebSocketListener();
        this.globalStore.getReleaseNoteInfo();
      })
      .catch(() => {
        // Session retrieval failed — guard will timeout gracefully
      });
  }

  public ngOnDestroy() {
    this.permissionsWsSub?.unsubscribe();
    this.releaseNotesDialogService.destroyDialog();
  }

  private initPermissionsWebSocketListener(): void {
    this.permissionsWsSub = this.websocketService.message.subscribe((res: WsMessageResponse) => {
      if (res.eventType === EventType.PERMISSIONS_CHANGED) {
        this.permissionStore.loadPermissions();
      }
    });
  }

  private onReleaseNotesLoad(): void {
    effect(() => {
      if (this.globalStore.releaseNoteInfo().shouldShow) {
        this.releaseNotesDialogService.openRelaseNotesDialog(false, true);
      }
    });
  }
}
